import { Component, OnInit, ChangeDetectionStrategy, signal, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { BaseComponent } from '@app/shared/base/components/base-component';
import { UserInfoComponent } from './user-info/user-info.component';
import { NavigationComponent } from './navigation/navigation.component';
import { ActionsComponent } from './actions/actions.component';

const SIDEBAR_COLLAPSED_KEY = 'hypecast.sidebarCollapsed';

@Component({
  selector: 'hypecast-master-admin-base-layout',
  templateUrl: './base-layout.component.html',
  styleUrls: ['./base-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UserInfoComponent, NavigationComponent, ActionsComponent, RouterOutlet],
})
export class BaseLayoutComponent extends BaseComponent implements OnInit {
  private router = inject(Router);

  /** Whether the slide-in navigation drawer is open on mobile (<768px). */
  readonly mobileNavOpen = signal(false);

  /** Whether the desktop sidebar is collapsed to a slim icon rail. Persisted. */
  readonly sidebarCollapsed = signal(localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === 'true');

  toggleMobileNav(): void {
    this.mobileNavOpen.update((isOpen) => !isOpen);
  }

  closeMobileNav(): void {
    this.mobileNavOpen.set(false);
  }

  toggleSidebar(): void {
    this.sidebarCollapsed.update((isCollapsed) => !isCollapsed);
    localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(this.sidebarCollapsed()));
  }

  ngOnInit() {
    // Close the mobile drawer after navigating so it doesn't cover the new page.
    super.addSubscription(
      this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe({
        next: () => this.closeMobileNav(),
        error: () => {
          /* router error handling lives elsewhere */
        },
      }),
    );
  }
}
